/* eslint-disable camelcase */
import React from 'react';

import { TinyNav, TinyNavMenu, TinyNavBarEnd } from './TinyTopNavStyles';

import TinyTopNavAnnouncement from './TinyTopNavAnnouncement/index';
import TinyTopNavLinks from './TinyTopNavLinks/index';

const TinyTopNav = navigation => (
  <TinyNav>
    <TinyNavMenu>
      {TinyTopNavAnnouncement(navigation)}
      <TinyNavBarEnd position="end">{TinyTopNavLinks(navigation)}</TinyNavBarEnd>
    </TinyNavMenu>
  </TinyNav>
);

export default TinyTopNav;
